import createSvgIcon from "./utils/create_icon"

const ErrorOutline = createSvgIcon(<><g fill="currentColor"><path d="M12 17a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3a1 1 0 0 1-1-1V8a1 1 0 1 1 2 0v5a1 1 0 0 1-1 1z" /><path clipRule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z" fillRule="evenodd" /></g></>, "ErrorOutline")
export default ErrorOutline
